import {fetchPersons} from "@/store/api/api";

export default {
    namespaced: true,
    state: {
        id: null,
        persons: [],
    },
    getters: {
        currentPersonId: (state) => state.id,
        getCurrentPerson: (state) =>
            state.persons.find(person => person.id === state.id),
        persons: (state) => {
            return state.persons.find(person => person.id === state.id);
        },
        getPersonsByNameIncludes: (state) => (str) => {
            if (str) return state.persons.filter((person) => {
                    return person.name
                        .toLowerCase()
                        .includes(str.toLowerCase().trim());
                }
            );
            return state.persons;
        },
        isPersonExist: (state) => (id) =>
            state.persons.some(person => person.id === id)
    },
    mutations: {
        setPersons(state, payload) {
            state.persons = payload;
        },
        setCurrentPerson(state, payload) {
            if (!payload) return;
            state.id = parseInt(payload);
        },
        clearPerson(state) {
            state.id = null;
        },
    },
    actions: {
        async fetchPersons({commit}, options) {
            const persons = await fetchPersons(options);
            commit('setPersons', persons);
        },
        setCurrentPerson({commit, dispatch}, id) {
            commit('setCurrentPerson', id);
            dispatch('config/saveStateToLocalStorage', null, {root: true});
        },
        clearPerson({commit, dispatch}) {
            commit('clearPerson');
            dispatch('clearPersonDependencies');
            dispatch('config/saveStateToLocalStorage', null, {root: true});
        },
        clearPersonDependencies({dispatch}) {
            dispatch('event/clearEvents', null, {root: true})
        }
    }
}
